import * as cmd from 'commander'
import { addCloudCommands } from './cmd/cloud'
import { addKubernetesCommands } from './cmd/kubernetes'
import { addOperationCommands } from './cmd/operation'
import { addPluginCommands } from './cmd/plugin'
import {
  applyAppBundle, deleteParameterValues, forkYamProcess, generateAppAndSettingsSchema, generateModel,
  initEngine, listParameterValues, planApply, previewTemplate, setParameterValues, validateWorkloadName
} from './ops/engine'
import { checkKubeConfAndContext } from './ops/kube'
import * as packageJson from './package.json'

let CLI_CREATED = false

export async function createCli(): Promise<void> {
  if (!CLI_CREATED) {
    CLI_CREATED = true
  } else {
    return
  }
  await initEngine()
  const program = cmd.program
  program.version(packageJson.version, '--cli-version', 'output the current version')
  program.command('version').action(() => { console.log(packageJson.version) })
  addOperationCommands(program)
  addPluginCommands(program)
  addCloudCommands(program)
  addKubernetesCommands(program)
  program.parse(process.argv)
}

export const Engine = {
  planApply,
  applyAppBundle,
  generateModel,
  validateWorkloadName,
  generateAppAndSettingsSchema,
  checkKubeConfAndContext,
  forkYamProcess,
  listParameterValues,
  setParameterValues,
  deleteParameterValues,
  previewTemplate
}

// while running with ts-node
if (process.env.RUN_CLI) {
  createCli()
}
